import React from 'react';


import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm} from 'views/FormElements';


import HttpService from 'service/HttpService';
import UserAPI from 'service/api/UserAPI';

const Form = ({isSubmitting, values, forgetPasswordLink}) => {

	let btnTxt = "";
	const mode = values.mode;
	
	if(mode === "VERIFY_EMAIL") btnTxt = "Send Verification Email";
	else btnTxt = "Log In";
	
	let submitBtn = btnTxt;
	if(isSubmitting === true)
		submitBtn = <span>{btnTxt} <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

	return <RGForm>
			<h4 style={{fontStyle: "italic", margin: "10px 0", textAlign: "center"}}>Login with your email address</h4>
			<Input name="email" type="text" label="Email: " style={{marginBottom: "0px"}} />

			{mode === "LOGIN" && 
				<Input name="password" type="password" label="Password: " style={{marginBottom: "0px", marginTop: "10px"}}/>
			}
			
			<Input name="mode" type="hidden" />
			
			<div className="flexRow" style={{justifyContent: "space-between", alignItems: "flex-end"}}>
				<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
						{submitBtn}
				</SubmitButton>

				{forgetPasswordLink}
			</div>
	</RGForm>
};

class LoginForm extends React.Component {

	constructor(props) {
		super(props);
		this.INIT_VALUES = {email: '', password: '', mode: "LOGIN"};

		if(this.props.formData)
			Object.assign(this.INIT_VALUES, this.props.formData);

		this.handleFormSubmission = this.handleFormSubmission.bind(this);
	}

	validationScheme() {
		return Yup.object().shape({
			email: Yup.string().required('Enter your email address.').email('Email address is invalid.'),
		    password: Yup.string().required('Enter your password.').min(6, "Password cannot be less than 6 chars."),
		});
	}

	handleFormSubmission(value, {setSubmitting, setFieldValue}) {

		if(value.mode === 'VERIFY_EMAIL') {
			UserAPI.sendVerificationEmail(value.email, function(success) {
				setSubmitting(false);
			});
		} else {
			HttpService.login(value.email, value.password, function(success, error) {
				if(success === false) {
					setSubmitting(false);
	
					if(error.message.toLowerCase().indexOf("verify your email") >= 0) {
						setFieldValue('mode', 'VERIFY_EMAIL');
					}
				}
			});
		}
		
	}


	render() {
		return <Formik enableReinitialize initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
						validationSchema={this.validationScheme} render={formikProps => {
							return <Form {...formikProps} forgetPasswordLink={this.props.forgetPasswordLink} />
						}} />
	}
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/views/user/LoginForm.js